
import { Vue, Component } from "vue-property-decorator";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { mdiAccountGroup } from "@mdi/js";

@Component
export default class MasterClassItem extends Vue {
  icons: any = {
    accountGroup: mdiAccountGroup,
  };

  openRegistrations() {
    this.$router.push({
      name: "event-registration",
      params: { eventId: this.$route.params.id },
      query: { from: "masterclass" },
    });
  }

  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "masterclass",
  });

  get caption() {
    return this.dataSource.model?.caption;
  }

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Мастер-классы",
        to: "/manage/masterclass/",
        exact: true,
      },
      {
        text: this.dataSource.model?.caption,
        disabled: true,
      },
    ];
  }
}
